import React from 'react';
// import UserNav from './userNav';
// import UserConnect from './userConnect';

import BiassesProducteurs from './biassesProducteurs'
import { useEffect, useState } from 'react';
import { useSelector } from "react-redux"
import { URL_COURTJUS_BACK, cle_COURTJUS } from '../constants/sources.js';
import ReactMarkdown from 'react-markdown';
import { NavLink } from "react-router-dom";

const Biasses = (props) => {

    const { userCJ } = useSelector(state => state);
    const [biasses, setBiasses] = useState([]);
    const headers = new Headers();
    headers.append('cle', cle_COURTJUS);


    useEffect(() => {
        fetch(`${URL_COURTJUS_BACK}/biasses`, {
            method: 'GET',
            headers: headers,
        })
            .then(response => response.json())
            .then(res => {
                setBiasses(res);
            });
    }, []);



    return (
        <main className="container">
            <div className="main-down"></div>
            {/* {userMenu===true && <UserNav />} */}
            {/* {userMenu===true && <UserConnect />} */}

            <section className='main-title'>
                <p>Marchés / Biasses</p>
            </section>
            {biasses.map((q, i) =>
                <section className={`section-prods ${q.bActif && 'section-prods-actif'}`} key={i}>
                    <article className="section-prods-fiche">
                        <h2>{userCJ.uAdmin > 0 &&
                            <NavLink to={`/biasses/${q.bNum}`} aria-label="Modifier la fiche" title="modifier la fiche"><img src="/img/edit_R.png" className={'btn-articles'} alt="Modifier la Biasse" /></NavLink>
                        }  {q.bLibelle}.</h2>
                        <p className="p-impact"> Le {q.bDate.substring(8, 10)}/{q.bDate.substring(5, 7)}/{q.bDate.substring(0, 4)}</p>
                        <h3>Commande entre
                            le <span className='p-impact'>{q.bDateCdeIni.substring(8, 10)}/{q.bDateCdeIni.substring(5, 7)}/{q.bDateCdeIni.substring(0, 4)} </span>
                            et le <span className='p-impact'>{q.bDateCdeEnd.substring(8, 10)}/{q.bDateCdeEnd.substring(5, 7)}/{q.bDateCdeEnd.substring(0, 4)}</span>
                        </h3>
                    </article>
                    <article className="section-prods-infos">
                        <ReactMarkdown>{q.bComment.replace(/\n/g, '  \n')}</ReactMarkdown>
                    </article>
                    <article className="section-prods-infos">
                        <BiassesProducteurs bParticipants={q.bParticipants} />
                    </article>
                </section>
            )}
            {userCJ.uAdmin > 0 &&
                <section className="section-prods  section-prods-form">
                    <article className="section-prods-fiche ">
                        <p>
                            <NavLink to={`/biasses/0`} aria-label="Ajouter un marché / une biasse" title="Ajouter un marché / une biasse" ><img src="/img/storefront_add.png" className={'btn-articles'} alt="Ajouter une biasse" /></NavLink>
                        </p>
                        <br />
                        <br />
                        <section className="section-prods-err"><p>Attention : vous ne devez pas activer plusieurs Biasses en même temps !</p></section>
                        <section className="section-prods-err"><p>Ne réutilisez jamais une biasse en changeant juste les informations !</p></section>
                        <br />
                    </article>
                </section>}
            <div className="main-down"></div>

        </main>

    )
}

export default Biasses;